export const FontFree_data = [
    {
        image: 'https://drive.google.com/uc?id=1uQvZiF5CVRDDMdoz4X0i726-qYjBo9Fz',
        title: 'Link-sharing app',
        language: ['HTML', 'CSS', 'JS'],
        description: "In this project, you'll build a fully-functional link-sharing app for developers! You'll practice working with image uploads, repeater fields, drag-and-drop, and more!",
        url: '1fto',
    },
    {
        image: 'https://www.frontendmentor.io/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fdz209s6jk%2Fimage%2Fupload%2Fv1685103757%2FChallenges%2Fzimchyd6aujs5y4h5wxd.jpg&w=828&q=75',
        title: 'Link-sharing app',
        language: ['HTML', 'CSS', 'JS'],
        description: "In this project, you'll build a fully-functional link-sharing app for developers! You'll practice working with image uploads, repeater fields, drag-and-drop, and more!",
        url: '2fto',
    },
    {
        image: 'https://www.frontendmentor.io/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fdz209s6jk%2Fimage%2Fupload%2Fv1678466647%2FChallenges%2Fidpgv9arkmvkojb2kxee.jpg&w=828&q=75',
        title: 'Link-sharing app',
        language: ['HTML', 'CSS', 'JS'],
        description: "In this project, you'll build a fully-functional link-sharing app for developers! You'll practice working with image uploads, repeater fields, drag-and-drop, and more!",
        url: '3fto',
    },
    {
        image: 'https://www.frontendmentor.io/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fdz209s6jk%2Fimage%2Fupload%2Fv1676299214%2FChallenges%2Flpwvfibpdyycvjpukkec.jpg&w=828&q=75',
        title: 'Link-sharing app',
        language: ['HTML', 'CSS', 'JS'],
        description: "In this project, you'll build a fully-functional link-sharing app for developers! You'll practice working with image uploads, repeater fields, drag-and-drop, and more!",
        url: '4fto',
    },
    {
        image: 'https://www.frontendmentor.io/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fdz209s6jk%2Fimage%2Fupload%2Fv1666363466%2FChallenges%2Fabbzt6kmkawmpbj7evxx.jpg&w=828&q=75',
        title: 'Link-sharing app',
        language: ['HTML', 'CSS', 'JS'],
        description: "In this project, you'll build a fully-functional link-sharing app for developers! You'll practice working with image uploads, repeater fields, drag-and-drop, and more!",
        url: '5fto',
    },
    {
        image: 'https://www.frontendmentor.io/_next/image?url=https%3A%2F%2Fres.cloudinary.com%2Fdz209s6jk%2Fimage%2Fupload%2Fv1643969912%2FChallenges%2Fmflwrbyf8kjvqvpxq9uj.jpg&w=828&q=75',
        title: 'Link-sharing app',
        language: ['HTML', 'CSS', 'JS'],
        description: "In this project, you'll build a fully-functional link-sharing app for developers! You'll practice working with image uploads, repeater fields, drag-and-drop, and more!",
        url: '6fto',
    },
]


export const FontFree_single_data = {
    '1fto': {
        image:
            [
                'https://drive.google.com/uc?id=1ZE5C2vMcC7j8vCR9BB5FGF6o1acVzHot',
                'https://drive.google.com/uc?id=1bHQH4HgpiotPZ2Uq_Sq0fG0SyCM9pe9J',
                'https://drive.google.com/uc?id=1wJVIp0Bpi8JmitRsmoZxxcb6cIpYOChI'
            ],
        title: 'Design Login Page',
        language: ['HTML', 'CSS'],
        description: "In this project, you'll build a fully-functional link-sharing app for developers! You'll practice working with image uploads, repeater fields, drag-and-drop, and more!",
        download: '1fto',
        responsive: true,
        project: [
            {
                heading: 'Desktop Section',
                image: 'https://drive.google.com/uc?id=1ZE5C2vMcC7j8vCR9BB5FGF6o1acVzHot',
                list:
                    [
                        'Login - should be in h1 tag with font: 60px, color: #FFF',
                        'input tag width: 80%, height: 50px',
                        'SUBMIT - width: 80%, background-color: #FFF',
                    ]
            },
            {
                heading: 'Tab Section',
                image: 'https://drive.google.com/uc?id=1bHQH4HgpiotPZ2Uq_Sq0fG0SyCM9pe9J',
                list:
                    ['inner background-color: black, opacity: 57%',
                        'Login - should be in h1 tag with font: 60px',
                        'input tag width: 90%, height: 45px',
                        'SUBMIT - width: 90%, background-color: #EA5114',
                    ]
            },
            {
                heading: 'Mobile Section',
                image: 'https://drive.google.com/uc?id=1wJVIp0Bpi8JmitRsmoZxxcb6cIpYOChI',
                list:
                    [
                        'Login - should be in h1 tag with font: 60px',
                        'input tag width: 90%, height: 45px',
                        'SUBMIT - width: 90%, background-color: #EA5114',
                    ]
            }
        ]
    },
}